import React from 'react';
import styles from '../ct_cleyton_alencar/ct_cleyton_alencar.module.scss';
import Perfil from './src/perfil.png';
import horariosValoresPdf from './src/horarios-valores.pdf';
import torneiosAnualPdf from './src/torneios-anual.pdf';
import midiaKitPdf from './src/midia-kit.pdf';
import LinkPersonalizado5 from '../../components/LinkPersonalizado5/linkPersonalizado5.tsx';

const Ct_cleyton_alencar: React.FC = () => {

    return (
        <div className={styles.ct_cleyton_alencar}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <p className="mb-0">Centro de treinamento</p>
                    <p>de Vôlei de Praia</p>
                    <div className={styles.links}>
                        <LinkPersonalizado5
                            href="https://wa.me/5517991753054?text=Olá, gostaria de agendar uma aula experimental."
                            title="AULA EXPERIMENTAL"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                        <LinkPersonalizado5
                            href={horariosValoresPdf}
                            title="HORÁRIOS E VALORES"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                        <LinkPersonalizado5
                            href={midiaKitPdf}
                            title="MÍDIA KIT"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                        <LinkPersonalizado5
                            href={torneiosAnualPdf}
                            title="TORNEIOS ANUAL INTERNO"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                        <LinkPersonalizado5
                            href="https://www.instagram.com/c.t_cleyton_alencar?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                        <LinkPersonalizado5
                            href="https://www.facebook.com/share/15TDhdRrBk/?mibextid=wwXIfr"
                            title="FACEBOOK"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                        <LinkPersonalizado5
                            href="https://maps.app.goo.gl/XhmYizekc1CMWgfV8"
                            title="LOCALIZAÇÃO"
                            maxWSpan={true}
                            backgroundColor="#303030"
                            backgroundColorHover="#000000"
                            colorText="#ed1698"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ct_cleyton_alencar;
